import '../vendor/slick.js';

if ($.isFunction($.fn.slick)) {
  const asyncFunc = 'requestIdleCallback' in window ? window.requestIdleCallback : window.requestAnimationFrame;
  const commonCarouselAttributes = {
    dots: true,
    infinite: true,
    nextArrow:
      '<button class="paddle paddle-right"><i class="fa fa-chevron-right"></i><span class="visually-hidden">Carousel next</span></button>',
    prevArrow:
      '<button class="paddle paddle-left"><i class="fa fa-chevron-left"></i><span class="visually-hidden">Carousel previous</span></button>',
    rows: 0,
    responsive: [
      {
        breakpoint: 928,
        settings: {
          arrows: false,
          dots: false,
          infinite: false,
          slidesToScroll: 4,
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          dots: false,
          infinite: false,
          slidesToScroll: 2,
          slidesToShow: 2.5,
        }
      }
    ]
  };

  let carouselAttributes = Object.assign({}, commonCarouselAttributes, { slidesToScroll: 6, slidesToShow: 6 });

  const spilloverCarouselAttributes = Object.assign({}, commonCarouselAttributes, {
    slidesToScroll: 5,
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 928,
        settings: {
          arrows: false,
          dots: false,
          infinite: false,
          slidesToScroll: 4,
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          dots: false,
          infinite: false,
          slidesToScroll: 2,
          slidesToShow: 2,
        }
      }
    ]
  });

  asyncFunc(function () {
    $('.recommender-carousel').slick(carouselAttributes);
    $('.spillover-carousel').slick(spilloverCarouselAttributes);

    try {
      const target = document.querySelectorAll('.recommender-wrapper');
      target.forEach((element) => {
        let unobserve, wasShown;
        const inHandler = (entry, unobserve, targetEl) => {
          wasShown = true;
          $(element)
            .find('img.lazy')
            .each(function () {
              const src = $(this).data('src');
              $(this).css('visibility', 'visible');
              $(this).attr('src', src);
            });
          $(element).css('animation', 'fadein 0.4s forwards');
        };

        const outHandler = (entry, unobserve, targetEl) => {
          if (wasShown) {
            unobserve();
          }
        };
        unobserve = window.observeElementInViewport(
          element,
          inHandler,
          outHandler,
          {
            window,
            threshold: [30],
          }
        );
      });
    } catch (error) {
      console.log('ERROR WITH RECOMMENDATIONS:', error);
      $('.recommender-wrapper').css('animation', 'fadein 0.4s forwards');
    }
  });
}
